import React from 'react';
import { RenderModule } from 'holocron';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { usePersonaExploreMore } from '../../hooks/usePersonaApi';
import { PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME } from '../../constants/modules';
import styles from '../ForYou/ForYou.scss';

export const ExploreMore = () => {
  const {
    heading,
    articles,
    personaType,
    isLoading: personaLoading,
  } = usePersonaExploreMore();
  const locale = useSelector(getActiveLocaleSelector);

  const [, market] = locale.toLowerCase().split('-');
  const analyticsElementPrefix = `${market}hp-explore-more-${personaType}`;

  return (
    <div data-testid="axp-travel-home-explore-more" className={`pad-4-tb ${styles.radiusOverride}`}>
      <RenderModule
        moduleName={PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME}
        props={{
          heading,
          articles,
          analyticsElementPrefix,
          isParentDataLoading: personaLoading,
        }}
      />
    </div>
  );
};

export default ExploreMore;
